<template>
    <div class="login-layout">
        <headerMain layout="login" />
        <main class="login">
            <router-view />
        </main>
        <footerMain/>
    </div>
</template>

<script>
import footerMain from '@/components/app/footerMain';
import headerMain from '@/components/app/headerMain';

export default {
  name: 'login-layout',
  components:{
    headerMain, footerMain
  }
};
</script>

<style lang="scss">
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '../assets/sass/app/app.scss';
</style>
